import apiUrl from '../../../constants';
import axios from 'axios';
//import Paginate from 'vuejs-paginate';
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import Loader from './../shared/loader'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import Pagination from './../shared/pagination'

export default {
	name: 'ProductCategory',
	components: {
		//Paginate,
		Pagination,
		Loader,
		DatePicker
	},
	data: function () {

		return {
			// currentPage: 0,
			currentPage: 1,
			totalPage: 0,
			totalCount: 0,
			pageLimit: 10,
			modalShow: false,
			showSelectWarehouse: false,
			WarehouseErr: '',
			addcategorymodal: false,
			productid: '',
			categoryname: '',
			isLoading: false,
			resultCount: '',
			// pageCount: 0,
			// pageNo: 0,
			// pageLimit: 5,
			status: '',
			changestatus: '',
			client: '',
			clientid: '',
			showSelectClient: false,
			ClientErr: '',
			ClientErrr: '',
			categorynameErrr: '',
			listClientData: [],
			categoryaction: '',
			categoryname: '',
			listProductCategoryData: [],
			ID: '',
			statusID: '',
			statusdata: '',
			userClientid: '',
			addproduct: {
				clientid: '',
				productid: '',
				categoryname: '',
				status: '',

			},
			user_type: '',
			listWarehouseData: [],
			warehouseid: '',
			warehouse: '',
			formattedDate: '',
		}
	},

	filters: {
		moment: function (date) {
			return moment(date).format('DD-MM-YYYY');
		},
		capitalize: function (value) {
			if (!value) return ''
			value = value.toString()
			return value.charAt(0).toUpperCase() + value.slice(1)
		}

	},

	mounted() {
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.user_type = userdetail.utype;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getProductCategoryData();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}
	},

	methods: {
		onchange() {
			if (this.addproduct.categoryname.trim() != '')
				this.categorynameErrr = ''
			else
				this.categorynameErrr = this.$t('productPlaceHolder.cateGoryNameError');
		},
		// getClientList() {
		// 	var userToken = window.localStorage.getItem('userToken');
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageNo = this.totalCount = 0;

		// 	this.input = ({
		// 		warehouseid: this.warehouseid
		// 	});

		// 	axios({
		// 		method: 'POST',
		// 		'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 		'data': this.input,
		// 		headers: {
		// 			'Authorization': 'Bearer ' + myStr,
		// 		}
		// 	})
		// 		.then(result => {
		// 			this.listClientData = result.data.data;
		// 		}, error => {
		// 			console.error(error);
		// 		});
		// },
		// getWarehouseList() {
		// 	var userToken = window.localStorage.getItem('userToken')
		// 	var myStr = userToken.replace(/"/g, '');
		// 	this.pageno = 0;
		// 	this.input = ({
		// 		clientid: this.clientid,
		// 	});

		// 	axios({
		// 		method: 'POST',
		// 		'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 		'data': this.input,
		// 		headers: {
		// 			'Authorization': 'Bearer ' + myStr
		// 		}
		// 	})
		// 		.then(result => {
		// 			this.listWarehouseData = result.data.data;
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.resultCount = 0
		// 		this.clientid = this.client;
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = [];
		// 			this.getWarehouseList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid);
		// 			// this.getGrclotreportData();
		// 		}
		// 	}
		// 	this.listProductCategoryData = [];
		// 	this.pageno = this.totalCount = 0;
		// },
		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalCount = 0;
		// 	this.resultCount = 0
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {

		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },

		//open new form(popup)
		addNewProductCategory() {
			//to initialize all form field or used for clear the form
			this.addproduct.clientid = '',
				this.addproduct.productid = '',
				this.addproduct.categoryname = '',
				this.addproduct.status = '',
				this.categoryaction = 'add',
				this.ClientErrr = '';
			this.categorynameErrr = '';
			this.addcategorymodal = true;
			this.$validator.reset();
			this.errors.clear();
			this.clearNewForm();
		},

		// Save Product Category Field
		saveProductCategory() {
			this.ClientErrr = '';
			this.categorynameErrr = '';

			if (this.user_type == 'client_user') { } else if (localStorage.getItem("selectedClient") == '' || localStorage.getItem("selectedClient") == null) {
				this.ClientErrr= this.$t('common.clientError');
				return false
			}
			if (this.addproduct.categoryname.trim() == '' || this.addproduct.categoryname == null) {
				this.categorynameErrr = this.$t('productPlaceHolder.cateGoryNameError');
				return false
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var self = this
			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
				categoryname: this.addproduct.categoryname
			})
			this.isLoading = true;
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'saveCategory',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then((response) => {
					if (response.data.errorCode == 0) {
						this.isLoading = false
						this.$alertify.success("Created Successfully")
						this.getProductCategoryData(),
							this.addcategorymodal = false
						this.clearNewForm()
					} else {
						this.isLoading = false
						this.$alertify.error("already existed")
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},

		//Update Product Category Field
		editProductCategory() {
			this.ClientErrr = '';
			this.categorynameErrr = '';

			if (this.user_type == 'client_user') { } else if (localStorage.getItem('selectedClient') == '' || localStorage.getItem('selectedClient') == null) {
				this.ClientErrr= this.$t('common.clientError');

				return false
			}
			if (this.addproduct.categoryname == '' || this.addproduct.categoryname == null) {
				this.categorynameErrr = this.$t('productPlaceHolder.cateGoryNameError');
				return false
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var self = this
			this.input = ({
				clientid: this.user_type == 'client_user' ? localStorage.getItem('selectedClient') : localStorage.getItem('selectedClient'),
				categoryname: this.addproduct.categoryname,
				id: this.ID,
			})
			this.isLoading = true;
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'updateCategory',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then((response) => {
					if (response.data.msg > 0) {
						this.isLoading = false
						this.$alertify.success("Product Category Record Updtaed Successfully");
						this.addcategorymodal = false;
						this.getProductCategoryData();
					} else {
						this.isLoading = false
						this.$alertify.error(" Category already existed")
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},

		//for active/inactive modal
		changeProductCategoryStatus() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'updateCategoryStatus',
				'data': {
					status: this.statusdata,
					id: this.statusID,
					clientid: localStorage.getItem('selectedClient')
				},
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then((response) => {
					if (response.data.errorCode == 0) {
						this.$alertify.success("Product Category Status update Successfully");
						this.getProductCategoryData();
						this.addcategorymodal = false;
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException);
				})
		},

		//to get target id in edit action
		getProductRowData(data) {
			this.$validator.reset();
			this.errors.clear();
			this.categoryaction = 'edit';
			this.ClientErrr = '';
			this.categorynameErrr = '';
			this.addcategorymodal = true;
			this.addproduct.categoryname = data.categoryname;
			this.addproduct.clientid = this.client;
			this.ID = data.id
		},
		getProductCategorySerach(check) {
			this.totalPage = 0;
			this.currentPage = 1;
			this.resultCount = 0;
			this.getProductCategoryData(check);
		},
		//to get product Category list
		getProductCategoryData(check) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				if (check == 1) {
					this.ClientErrr= this.$t('common.clientError');
					this.$alertify.error(this.$t('common.clientError'))
				}
				this.pageno = this.totalCount = 0;
				this.listProductCategoryData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse") =='') {
				if (check == 1) {
					this.WarehouseErr =this.$t('common.warehouseError');
					this.$alertify.error(this.$t('common.warehouseError'))
				}
				this.pageno = this.totalCount = 0;
				this.listProductCategoryData = [];
				return false;
			}
			this.input = ({
				clientid: this.clientid,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				categoryname: this.categoryname,
			});
			// this.isLoading = true;
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getProductcategorylist',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.listProductCategoryData = result.data.data.rows;
					this.isLoading = false
					// let totalRows = result.data.data.count
					// this.resultCount = result.data.data.count
					// if (totalRows < this.pageLimit) {
					// 	this.pageCount = 1
					// } else {
					// 	this.pageCount = Math.ceil(totalRows / this.pageLimit)
					// }
					this.totalCount = result.data.data.count
					this.resultCount = result.data.data.count;
					if (this.totalCount < 10) {
						if (this.totalCount == 0) {
							this.totalPage = 0
						} else {
							this.totalPage = 1
						}
					} else {
						this.totalPage = Math.ceil(this.totalCount / 10);
					}
				}, error => {
					console.error(error);
				})
		},

		//to get target id in active/inactive modal
		getStatusRowData(data) {
			this.statusID = data.id
			this.statusdata = data.status
			this.Statusaction = 'add'
			this.modalShow = true
			this.status = data.status
			if (data.status.trim() == 'active') {
				this.changestatus = 'De-Activate'
			} else {
				this.changestatus = 'Activate'
			}
		},

		//Sets total number of pages
		setPageCounts(total_rows) {
			if (total_rows > 0) {
				if (total_rows <= this.pageLimit) {
					this.totalCount = 1;
				} else {
					this.totalCount = Math.ceil(total_rows / this.pageLimit);
				}
			} else {
				this.totalCount = 0;
			}
		},
		// status popup modal
		addmodalShow() {
			this.Statusaction = 'add'
			this.addmodalShow = true
		},
		// close status model
		closeStatusProductCategoryModal() {
			this.modalShow = false
		},

		//to close new form
		closeAddProductCategoryModal() {
			this.addcategorymodal = false
		},

		//Call page number from pagination
		// getPaginationData(currentPage) {
		// 	this.pageNo = (currentPage - 1) * this.pageLimit;
		// 	this.getProductCategoryData();
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getProductCategoryData()
		},
		//clear new form if added
		clearNewForm() {
			this.addproduct = {};
			this.addproduct.clientid = '';
			this.addproduct.categoryname = '';
			this.getProductCategoryData();
			this.$validator.reset();
			this.errors.clear();
		},

		//reset search filter
		resetForm() {
			this.resultCount = 0
			this.ClientErr = '';
			this.productid = '';
			this.categoryname = '';
			// this.clientid = '';
			this.WarehouseErr = '';
			// this.getProductCategoryData();
			this.listProductCategoryData = [];
			this.pageNo = this.totalCount = 0;
			// if (this.user_type == 'warehouse_user')
			// 	this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }
		},

		//validate all form fields on onsubmit()
		onSubmit: function (event) {
			this.$validator.validateAll(result).then(() => {
				if (result) {
					event.target.reset();
					console.log('form is valid', this.model)
				} else {
					console.log('errors exist', this.errors)

				}
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		}
	}
}


// WEBPACK FOOTER //
// ./src/views/components/categorymaster/categorymaster.component.js